import React from 'react';
import ASale from './a-sale';
/**
 * セール要素を生成して返す
 */
const createSaleElements = (saleOrder) => {
    return saleOrder.map((saleProp, index) => {
        return (React.createElement(ASale, { saleProp: saleProp, key: index }));
    });
};
const ASaleGroup = ({ saleOrder }) => {
    return (React.createElement("div", { id: "js-sale-group" }, createSaleElements(saleOrder)));
};
export default ASaleGroup;
